import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { ThemeProvider } from "styled-components";
import App from "./App";
import cognitoAuthConfig from "./authConfig";
import theme from "./theme";
import GlobalStyles from "./components/GlobalStyles";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </AuthProvider>
);
